import { F as Form, d as defineCustomElement$1 } from './form.js';

const TtForm = Form;
const defineCustomElement = defineCustomElement$1;

export { TtForm, defineCustomElement };
